import { render, staticRenderFns } from "./cancel-reject-dialog.vue?vue&type=template&id=2c850b3d&"
import script from "./cancel-reject-dialog.vue?vue&type=script&lang=js&"
export * from "./cancel-reject-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports